module.exports = __webpack_public_path__ + "img/dazi_img4.b69149f2.png";